interface IKeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

export const keycloakConfig: IKeycloakConfig = {
  clientId: 'react-starter',
  url: 'https://keycloak.spectrumtoolbox.com/auth',
  realm: 'spectrumtoolbox',
};
